/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TakedownEvent } from './TakedownEvent';
import {
    TakedownEventFromJSON,
    TakedownEventFromJSONTyped,
    TakedownEventToJSON,
    TakedownEventToJSONTyped,
} from './TakedownEvent';

/**
 * 
 * @export
 * @interface PaginatedTakedownEventList
 */
export interface PaginatedTakedownEventList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTakedownEventList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTakedownEventList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTakedownEventList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<TakedownEvent>}
     * @memberof PaginatedTakedownEventList
     */
    results: Array<TakedownEvent>;
}

/**
 * Check if a given object implements the PaginatedTakedownEventList interface.
 */
export function instanceOfPaginatedTakedownEventList(value: object): value is PaginatedTakedownEventList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedTakedownEventListFromJSON(json: any): PaginatedTakedownEventList {
    return PaginatedTakedownEventListFromJSONTyped(json, false);
}

export function PaginatedTakedownEventListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedTakedownEventList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(TakedownEventFromJSON)),
    };
}

  export function PaginatedTakedownEventListToJSON(json: any): PaginatedTakedownEventList {
      return PaginatedTakedownEventListToJSONTyped(json, false);
  }

  export function PaginatedTakedownEventListToJSONTyped(value?: PaginatedTakedownEventList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(TakedownEventToJSON)),
    };
}

